import { ReviewsContext } from "contexts/MightyTool";
import { useContext } from "react";
const useReviews = () => useContext(ReviewsContext);
export default useReviews;
